/**
 * Set templates order from MenuCategories
 *
 * @param template Template name
 *
 * @returns Template order
 */
export function indexHomeTemplates(template: string): number {
    switch (template) {
        case 'ItxHomeMenPage':
            return 1;
        case 'ItxHomeBgPage':
            return 2;
        default:
            return 0;
    }
}
